import auth from "./auth";
import documento from "./documento";

// eslint-disable-next-line
export default {
  auth,
  documento,
};
